import React, { useEffect, useState, createElement } from 'react';
// Cookie helper functions
const setCookie = (name: string, value: string, days: number = 7) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};
const getCookie = (name: string) => {
  const cookieName = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return '';
};
export const Hero = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Debug log to check component rendering
    console.log('Hero component mounted');
    // Check if timer exists in cookies or set default
    const storedTimer = getCookie('specialOfferTimer');
    if (storedTimer) {
      try {
        setTimeLeft(JSON.parse(storedTimer));
      } catch (error) {
        // If JSON parsing fails, reset to default
        setTimeLeft({
          hours: 4,
          minutes: 59,
          seconds: 59
        });
      }
    }
    // Timer logic for countdown
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        let newHours = prevTime.hours;
        let newMinutes = prevTime.minutes;
        let newSeconds = prevTime.seconds - 1;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        if (newHours < 0) {
          // Reset to 4:59:59 when timer reaches zero
          newHours = 4;
          newMinutes = 59;
          newSeconds = 59;
        }
        const newTime = {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
        // Save to cookie with 7-day expiration
        setCookie('specialOfferTimer', JSON.stringify(newTime), 7);
        return newTime;
      });
    }, 1000);
    // Load Wistia player scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.body.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/zk6pl2wqsw.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.body.appendChild(embedScript);
    return () => {
      clearInterval(timer);
      // Clean up scripts when component unmounts
      document.body.removeChild(playerScript);
      document.body.removeChild(embedScript);
    };
  }, []);
  return <div className="bg-gradient-to-b from-blue-900 to-blue-800 py-8 md:py-20 relative overflow-hidden hero-section" data-id="element-123">
      {/* Mobile-only timer - now fixed at top of screen */}
      <div className="md:hidden fixed top-0 left-0 w-full bg-red-600 text-white text-center py-1.5 px-2 shadow-md z-50" data-id="element-124">
        <p className="font-bold text-xs" data-id="element-125">
          LIMITED TIME OFFER: Ends in{' '}
          <span className="text-yellow-300" data-id="element-126">
            {String(timeLeft.hours).padStart(2, '0')}:
            {String(timeLeft.minutes).padStart(2, '0')}:
            {String(timeLeft.seconds).padStart(2, '0')}
          </span>
        </p>
      </div>
      {/* Add padding to top on mobile to prevent content from being hidden behind the fixed timer */}
      <div className="md:hidden h-8" data-id="element-127"></div>
      {/* American flag-inspired background elements */}
      {/* Stars element - hidden on mobile */}
      <div className="absolute top-4 left-4 md:top-8 md:left-8 hidden md:block" data-id="element-128"></div>
      <div className="container mx-auto px-3 max-w-6xl relative z-10" data-id="element-129">
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-12" data-id="element-130">
          <div className="md:w-1/2" data-id="element-131">
            {/* Bestseller ribbon above headline */}
            <div className="flex items-center mb-2 md:mb-4" data-id="element-132">
              <div className="bg-red-700 text-white px-3 py-0.5 rounded-full font-bold text-xs shadow-md" data-id="element-133">
                BESTSELLER
              </div>
              <div className="flex ml-2" data-id="element-134">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 24 24" data-id="element-135">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-136" />
                  </svg>)}
              </div>
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-2 md:mb-4" data-id="element-137">
              Charlie Kirk: Life, Quotes & Legacy
            </h1>
            <h2 className="text-lg md:text-2xl text-blue-300 md:text-red-300 font-medium mb-2 md:mb-6" data-id="element-138">
              The young philosopher who turned a microphone into a movement
            </h2>
            <p className="text-base md:text-xl font-semibold text-blue-200 md:text-gray-100 mb-3 md:mb-6" data-id="element-139">
              A patriotic voice for America's future
            </p>
            {/* Desktop-only button under the "A patriotic voice" text */}
            <div className="hidden md:block mb-8" data-id="element-140">
              <a href="#offer" className="inline-block w-full max-w-md bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300 border-2 border-white shadow-lg relative z-20 text-center" data-id="element-141">
                Get My Copy Now
              </a>
            </div>
          </div>
          <div className="md:w-1/2 relative mt-2 md:mt-0" data-id="element-142">
            {/* Wistia Video Player with enhanced border effect */}
            <div className="relative w-full max-w-md mx-auto rounded-md overflow-hidden z-10 border-8 border-white shadow-[0_0_30px_rgba(0,0,0,0.3),0_0_60px_rgba(59,130,246,0.4),0_0_90px_rgba(220,38,38,0.3)]" data-id="element-143">
              <style dangerouslySetInnerHTML={{
              __html: `
                wistia-player[media-id='zk6pl2wqsw']:not(:defined) { 
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/zk6pl2wqsw/swatch'); 
                  display: block; 
                  filter: blur(5px); 
                  padding-top: 56.25%; 
                }
              `
            }} data-id="element-144" />
              <wistia-player media-id="zk6pl2wqsw" aspect="1.7777777777777777" className="w-full" data-id="element-145"></wistia-player>
            </div>
            {/* Button moved below the video player - visible only on mobile */}
            <div className="mt-4 flex justify-center md:hidden" data-id="element-146">
              <a href="#offer" className="inline-block w-full max-w-md mx-auto bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-6 rounded-lg text-base transition-colors duration-300 border-2 border-white shadow-lg relative z-20 text-center" data-id="element-147">
                YES! I Want This Book
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};